module.exports = __webpack_public_path__ + "static/img/jiaotong.d08adfcd.png";